import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { BsXLg } from "react-icons/bs";
import { FiPhoneCall } from "react-icons/fi";
import { MdOutlineBackspace, MdOutlineErrorOutline } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import sound from '../../assets/audio/Dialpad.wav';
import CountryCode from '../../config/countryCodes.json';
import Mandatory_Masking from '../../config/Mandatory_Masking.json';
import Mandatory_Status from '../../config/Mandatory_Status.json';
import { agentSliceAction } from '../../store/agentSlice';
import { SendLogs } from '../../utils/awsAPI';
import { getMaskNumbersData, postCallbackID } from '../../utils/utils';

interface MaskNumberItem {
    ElementName: string;
}


const Dailpad = () => {
    const [alertDisplay, setAlertDisplay] = useState(false)
    const [alertDisplayMessage, setalertDisplayMessage] = useState("")
    const clickSound = new Audio(sound);
    const dispatch = useDispatch()
    const agentObj = useSelector((state: any) => { return state.agentSlice.agentObj })
    const contactObj = useSelector((state: any) => { return state.contactSlice.contactObj })
    const maskNumber = useSelector((state: any) => { return state.agentSlice.maskNumber })
    const [agentCurrentState, setAgentCurrentState] = useState<any>("");
    const [dialNumber, setDialNumber] = useState<any>("");
    const [country, setCountry] = useState<any>(JSON.parse(process.env.REACT_APP_DEFAULT_OUTBOUND_FLAG || '{"name":"United States of America", "flag":"images/flags/us.png","code":"+1"}'))
    const [callError, setCallError] = useState<any>("")
    const [show, setShow] = useState(false);
    const handleClose = () => { setShow(false); setSelectedQuickConnect("-----"); setDialNumber(""); dispatch(agentSliceAction.setMaskNumber(null)); setAlertDisplay(false); };
    const handleShow = () => setShow(true);
    const [maskNumberData, setMaskNumberData] = useState<any>([])
    const [quickContactList, setQuickContactList] = React.useState([]);
    const [SelectedQuickConnect, setSelectedQuickConnect] = useState<string>("------");
    // quick connects




    const getQuickContactListNumbers = async () => {
        let routingProfile = agentObj.getRoutingProfile();
        agentObj.getEndpoints([routingProfile.defaultOutboundQueue.queueARN], {
            success: function (data: any) {
                let PhoneNumbers = data.endpoints.filter((endpoints: any) => endpoints.type === "phone_number");
                setQuickContactList(PhoneNumbers);
            },
            failure: function () {

            }
        });
    }
    //quick connects





    useEffect(() => {
        if (agentObj) {
            setMaskNumberData(getMaskNumbersData(agentObj.getRoutingProfile().name))
            setAgentCurrentState(agentObj.getState().name)
            agentObj?.onRefresh(() => {
                setAgentCurrentState(agentObj.getState().name)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agentObj])

    const onDialNumber = (number: string) => {
        if (agentCurrentState === "Busy") {
            contactObj?.getAgentConnection().sendDigits(number, {
                success: function () {
                    console.log("Digit send successfully")
                },
                failure: function (err: any) { /* ... */ }
            });
        }

        let inputData = dialNumber + number;
        let result = "";
        if (inputData.length > 3) {
            result = inputData.substring(0, 4);
        } else {
            result = inputData
        }
        CountryCode.filter((item: any) => {
            if (item.code === result) {
                setCountry(item)
                return item
            }
            return false;
        })
        if (isDialpadSoundsEnabled()) {
            clickSound.play();
        }
        setDialNumber(dialNumber + number);
        setCallError("")
    }

    const isDialpadSoundsEnabled = () => {
        return localStorage.getItem("dialpadSounds") === null || localStorage.getItem("dialpadSounds") === 'true'
    }

    const onChangeNumber = (event: any) => {
        const Regx = new RegExp("[0-9,+]")
        const inputNumber = event.target.value;
        const inputValueArray = inputNumber.split("")
        let validNumbers: any = []

        inputValueArray.map((digit: any) => {
            if (Regx.test(digit)) {
                if (agentCurrentState === "Busy") {
                    contactObj?.getAgentConnection().sendDigits(digit, {
                        success: function () {
                            console.log("Digit send successfully")
                        },
                        failure: function (err: any) { /* ... */ }
                    });
                }
                validNumbers.push(digit)
                let inputData = validNumbers.join("");
                let result = "";
                if (inputData.length > 3) {
                    result = inputData.substring(0, 4);
                } else {
                    result = inputData
                }
                CountryCode.filter((item: any) => {
                    if (item.code === result) {
                        setCountry(item)
                        return item
                    }
                    return false;
                })
                if (isDialpadSoundsEnabled()) {
                    clickSound.play();
                }
            }
            return 0;
        })
        setDialNumber(validNumbers.join(""))
        setCallError("")
    }

    const onClear = () => {
        agentSliceAction.setMaskNumber("")
        setDialNumber("")
        setCallError("")
    }

    const onClickBack = () => {
        let newNumber = dialNumber.slice(0, -1)
        setDialNumber(newNumber)
        setCallError("")
    }

    const onMakeCall = () => {
        let mandatory_status = !Mandatory_Status.includes(agentObj.getRoutingProfile().name.split(" ")[0])


        if (agentObj.getState().name === "Offline" && mandatory_status) {
            setAlertDisplay(true);
            setalertDisplayMessage("Please change to another status, calls are forbidden in Offline");
            return;
        }


        if (dialNumber === '') {
            setAlertDisplay(true);
            setalertDisplayMessage("Missing phone number, please check");
            return;
        }

        let mandatory_mask = Mandatory_Masking.includes(agentObj.getRoutingProfile().name.split(" ")[0])

        if (!maskNumber && mandatory_mask) {
            setAlertDisplay(true);
            setalertDisplayMessage("Missing account name, please check");
            return;
        }
        if (maskNumber && maskNumberData.length <= 0 && mandatory_mask) {
            setAlertDisplay(true);
            setalertDisplayMessage("Missing account name, please check");
            return;
        }
        if (maskNumberData.length > 0 && !maskNumber && mandatory_mask) {
            setAlertDisplay(true);
            setalertDisplayMessage("Missing account name, please check");
            return;
        }

        let checkPluseSign = dialNumber.substring(0, 1)
        let finalNumber = (checkPluseSign !== "+") ? country.code + dialNumber : dialNumber;
        const endpoint = connect.Endpoint.byPhoneNumber(finalNumber);

        if (agentCurrentState === "Busy") {
            setDialNumber(finalNumber)
            contactObj.addConnection(endpoint, {
                success: function () {
                    console.log("ConnectionComponent::AddInCall::Add In Call Success");
                    handleClose()

                    setDialNumber("");
                    setCallError("")
                },
                failure: function (err: any) {
                    let error = JSON.parse(err)
                    if (error.type === 'BadEndpointException') {
                        setCallError("Phone number is invalid")
                    }
                    console.log("ConnectionComponent::AddInCall::Add In Call Failed");
                }
            })
        } else {
            try {
                agentObj.connect(endpoint, {
                    success: function () {
                        console.log("outbound call connected")
                        handleClose()
                        setDialNumber("");
                        setCallError("")
                    },
                    failure: function (err: any) {
                        let error = JSON.parse(err)
                        connect.agent((agent) => {
                            let agentData = agent.toSnapshot().getConfiguration()
                            SendLogs(agentData.username, agentData.softphoneAutoAccept, agentData.routingProfile.name, agent.getContacts().map(contact => contact.contactId), error.type + ": " + error.message)
                        })
                        console.log(JSON.stringify(error))
                        if (error.type === 'BadEndpointException') {
                            setCallError("Phone number is invalid")
                        }
                    }
                })
            } catch (error) {
                connect.agent((agent) => {
                    console.log("this was an agent object", agentObj)
                })
            }
        }

    }

    const onChangeCountry = (countryData: any) => {
        setCountry(countryData)
        setDialNumber(countryData.code + dialNumber)
    }

    const onMaskNumberChange = (element: any) => {

        if (agentObj) {
            let username = agentObj?.getConfiguration()?.username || "No agent";
            let CBNumber = element.ElementValue;
            dispatch(agentSliceAction.setMaskNumber(CBNumber))
            postCallbackID(username, CBNumber)
        }
    }

    return (
        <React.Fragment>
            <Button aria-label="Dial pad" className='dailbox bg-primary' onClick={handleShow}>
                <span className='dailbox-icon'><FiPhoneCall /></span>
            </Button>

            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
                <Modal.Header className='dailpad-header'>
                    <Modal.Title>Dialpad</Modal.Title>
                    <button className='close-btn-x' onClick={handleClose}>
                        <BsXLg />
                    </button>

                </Modal.Header>
                <Modal.Body>
                    <div className='row' onKeyPress={(e) => { if (e.key === "Enter") { onMakeCall() } }}>
                        <div className='col-12'>
                            <h5 className='text-darkblue text-center b-bottom'> Outgoing call</h5>
                            {alertDisplay && <Alert variant="danger" onClose={() => setAlertDisplay(false)} dismissible>
                                <strong>{alertDisplayMessage}</strong>
                            </Alert>}
                            <div className='d-flex justify-content-center SubMenus'>
                                <div className="dropdown">
                                    <label className="MaskNumber">QuickConnects</label>
                                    <button type="button" onClick={() => { getQuickContactListNumbers() }} className="btn btn-sm dropdown-toggle btn-outline-orange" data-bs-toggle="dropdown"> {SelectedQuickConnect} </button>
                                    <ul className="dropdown-menu">
                                        {quickContactList.map(({ phoneNumber, name }) =>
                                            <li key={phoneNumber}><button onClick={() => {
                                                setDialNumber(phoneNumber)
                                                setSelectedQuickConnect(name)
                                            }} className="dropdown-item">{name}</button></li>)
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className='d-flex justify-content-center SubMenus'>
                                {maskNumberData.length > 0 &&


                                    <div className="dropdown">
                                        <label className="MaskNumber">Account name</label>
                                        <button type="button" className="btn btn-sm dropdown-toggle btn-outline-orange" data-bs-toggle="dropdown">
                                            {maskNumber || '------'}
                                        </button>
                                        <ul className="dropdown-menu">
                                            {maskNumberData && maskNumberData
                                                .sort((a: MaskNumberItem, b: MaskNumberItem) => a.ElementName.localeCompare(b.ElementName)) // Ordenar alfabéticamente
                                                .map((item: MaskNumberItem, index: number) => {
                                                    return (
                                                        <li key={index}>
                                                            <button onClick={() => { onMaskNumberChange(item) }} className="dropdown-item">
                                                                {item.ElementName}
                                                            </button>
                                                        </li>
                                                    )
                                                })}
                                        </ul>
                                    </div>

                                }


                            </div>

                            <div className='call-input-box'>

                                <div className='call-box'>
                                    <div className='call-input-icon'><FiPhoneCall /></div>
                                    <div className="dropdown flag-box">
                                        <button type="button" className="dropdown-toggle me-3" data-bs-toggle="dropdown">
                                            <span className='flag-value'><img className='logo-src' src={country.flag} alt="flag" /></span>
                                        </button>
                                        <ul className="dropdown-menu flag-list">
                                            {CountryCode && CountryCode.map((country: any, index: number) => {
                                                return (
                                                    <li onClick={() => { onChangeCountry(country) }} key={index}>
                                                        <span className='flag-img'><img className='logo-src' src={country.flag} alt="flag" /></span>
                                                        <span className='c-name'>{country.name}</span>
                                                        <span className='c-code'>{country.code}</span>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                    <div className='call-input'>
                                        <input value={dialNumber} autoFocus onChange={(event) => { onChangeNumber(event) }} type="text" placeholder='Enter number here' />
                                    </div>
                                </div>
                            </div>
                            {callError && <div className='error-text text-danger text-center'><MdOutlineErrorOutline /> {callError} </div>}
                            <div className='col-12'>
                                <div className="dailpaid-box">
                                    <div className="keypad-wapper">
                                        <div className="keypad-row">
                                            <button onClick={() => { onDialNumber("1") }} value="1" className="key-button border-rb">
                                                <div className="number-key">1</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("2") }} value="2" className="key-button border-rb">
                                                <div className="number-key">2</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("3") }} value="3" className="key-button border-b">
                                                <div className="number-key">3</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={() => { onDialNumber("4") }} value="4" className="key-button border-rb">
                                                <div className="number-key">4</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("5") }} value="5" className="key-button border-rb">
                                                <div className="number-key">5</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("6") }} value="6" className="key-button border-b">
                                                <div className="number-key">6</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={() => { onDialNumber("7") }} value="7" className="key-button border-rb">
                                                <div className="number-key">7</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("8") }} value="8" className="key-button border-rb">
                                                <div className="number-key">8</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("9") }} value="9" className="key-button border-b">
                                                <div className="number-key">9</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={() => { onDialNumber("*") }} value="*" className="key-button border-rb">
                                                <div className="number-key">*</div>
                                            </button>
                                            <button onClick={() => { onDialNumber("0") }} value="0" className="key-button border-rb">
                                                <div className="number-key">0</div>

                                            </button>
                                            <button onClick={() => { onDialNumber("#") }} value="#" className="key-button border-b">
                                                <div className="number-key">#</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={() => { onClear() }} className="key-button border-r">
                                                <div className="number-key"><i className="far fa-trash-alt"></i></div>
                                            </button>
                                            <button onClick={() => { onDialNumber("+") }} className="key-button border-r">
                                                <div className="char-key">+</div>
                                            </button>
                                            <button onClick={() => { onClickBack() }} className="key-button">
                                                <div className="number-key"><MdOutlineBackspace /></div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <Button onClick={() => { onMakeCall() }} className='w-100 btn btn-success btn-lg'><FiPhoneCall /> Call</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}
export default Dailpad;
